import {API} from 'aws-amplify'
import {apiCallWithAuthCheck} from '../auth/core/AuthErrorInterceptor'

// Personal Access Tokens for the OmicsBox engine (CLI). These call the same
// JobService cloud API as the rest of the app; the Authorization: Bearer <idToken>
// header is injected automatically by Amplify (see src/aws-config.ts).
const apiName: string = process.env.REACT_APP_API_NAME || 'JobService'

/** Key metadata as returned by GET /v1/tokens (never includes the secret). */
export interface ApiKey {
  /** sha256 of the key — the public id used for revocation. */
  id: string
  name: string
  tier: string
  subscriptionId: string
  scopes: string[]
  createdAt: number
  expiresAt: number
  lastUsedAt?: number | null
  revoked: boolean
}

export interface ListTokensResponse {
  keys: ApiKey[]
}

/** POST /v1/tokens returns the plaintext key ONCE, plus the same metadata. */
export interface CreateTokenResponse {
  apiKey: string
  id: string
  name: string
  tier: string
  subscriptionId: string
  scopes: string[]
  createdAt: number
  expiresAt: number
}

export const listTokens = async (): Promise<ListTokensResponse> =>
  apiCallWithAuthCheck(async () => API.get(apiName, 'v1/tokens', {}))

export const createToken = async (
  name: string,
  expiresInDays: number,
  subscriptionId?: string
): Promise<CreateTokenResponse> =>
  apiCallWithAuthCheck(async () =>
    API.post(apiName, 'v1/tokens', {
      body: subscriptionId ? {name, expiresInDays, subscriptionId} : {name, expiresInDays},
    })
  )

export const deleteToken = async (id: string): Promise<void> =>
  apiCallWithAuthCheck(async () => {
    await API.del(apiName, `v1/tokens/${id}`, {})
  })
